'use client';

import Link from 'next/link';

import BrandLogo from '@/fo/icons/base/icons/logo.svg';
import TgIcon from '@/fo/icons/base/icons/tg.svg';
import VkIcon from '@/fo/icons/base/icons/vk.svg';

import { footerData } from './mock';
import { type FooterData } from './types';
import { styles } from './UiAppFooterCheckout.styles';

const socialMap = {
  vk: VkIcon,
  telegram: TgIcon
} as const;

type SocialCode = keyof typeof socialMap;
export interface UiAppFooterCheckoutProps {
  data: FooterData;
  socials: {
    code: SocialCode;
    label: string;
    value: string;
  }[];
  logo?: string | null;
  logoAlt?: string | null;
  customVariables?: {
    [key: string]: string | unknown[];
  };
}

export function UiAppFooterCheckout({
  data,
  socials,
  customVariables
}: UiAppFooterCheckoutProps) {
  const slots = styles();
  const { copyright } = footerData ?? data;

  return (
    <div className={slots.base()}>
      <div className={slots.container()}>
        <div className={slots.brandsSection()}>
          <div className={slots.brandBlock()}>
            <BrandLogo />
          </div>
          <div className={slots.copyright()}>
            {copyright.text.map((text, index) => (
              <span
                key={index}
                className={slots.copyrightText()}
              >
                {text}
              </span>
            ))}
          </div>
        </div>
        <div className={slots.infoSection()}>
          <div className={slots.contactWrapper()}>
            {customVariables?.phone && (
              <div className={slots.phoneBlock()}>
                <Link
                  href={`tel:${customVariables?.phone}`}
                  className={slots.phoneNumber()}
                >
                  {customVariables?.phone as string}
                </Link>
              </div>
            )}
            {customVariables?.email && (
              <Link
                href={`mailto:${customVariables?.email}`}
                className={slots.email()}
              >
                {customVariables?.email as string}
              </Link>
            )}
          </div>
          <div className={slots.contactWrapper()}>
            {socials &&
              socials.map((item, index) => {
                const SocialIcon = socialMap[item.code];

                return (
                  <a
                    key={index}
                    href={`mailto:${item.value}`}
                    className={slots.social()}
                  >
                    <SocialIcon className={slots.socialIcon()} /> {item.label}
                  </a>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
